import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
  computed,
  input,
} from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { TagModule } from 'primeng/tag';
import { TooltipModule } from 'primeng/tooltip';
import { OverlayPanelModule } from 'primeng/overlaypanel';

export interface PillItem {
  id: string;
  label: string;
  icon?: string;
}

/**
 * Renders a single-line list of clickable pills. Only the first `maxVisible`
 * items are shown inline; the rest are collapsed into a "+N" pill that opens
 * an overlay listing all items.
 */
// NG21-MIGRATION: p-overlayPanel -> p-popover (primeng/popover)
@Component({
  selector: 'app-pill-list',
  standalone: true,
  imports: [NgTemplateOutlet, TagModule, TooltipModule, OverlayPanelModule],
  templateUrl: './pill-list.component.html',
  styleUrl: './pill-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PillListComponent {
  readonly items = input<PillItem[] | undefined>([]);
  readonly maxVisible = input(2);
  readonly itemTooltip = input('');

  @Output() itemClick = new EventEmitter<string>();

  readonly allItems = computed(() => this.items() ?? []);
  readonly visibleItems = computed(() =>
    this.allItems().slice(0, this.maxVisible())
  );
  readonly hiddenCount = computed(
    () => this.allItems().length - this.visibleItems().length
  );

  onItemClick(id: string, event: Event) {
    event.stopPropagation();
    this.itemClick.emit(id);
  }
}
